import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-text-box[formGroup][propertyName]',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss'],
  standalone: false,
})
export class TextBoxComponent extends BaseFormComponent implements OnDestroy {

  @Input() maxLength? = 250;
  @Input() FIELD_SPACING: number;
  @Input() LABEL_SPACING: number;
  
  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnDestroy(): void {    
    try {
      if (this.formGroup.get(this.propertyName) != undefined) {
        this.formGroup.controls[this.propertyName].setValue('');
      }
     } catch(ex) {
       console.log('[TextBoxComponent] ngOnDestroy this.propertyName='+ this.propertyName +' userAction ex' + ex.message);
     } 
  }

}
